<template>
    <!-- <div class="checkbox-selector" 
      :class="rightAlign ? 'checkbox-selector-right' : ''"
      @click="$emit('click')">
      <v-icon 
        :color="item.selected ? 'green' : 'gray'" 
        style="
          font-size: 19px;
        ">
        {{ item.selected ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}</v-icon>
    </div> -->
    <!-- <v-checkbox :value="item.selected" 
      color="green" 
      dense
      @click="clicked"
      @change="changed">
      </v-checkbox> -->
    <v-simple-checkbox :value="item.selected" 
      color="green" 
      class="rm-cb"
      @click="clicked"
      @input="changed">
      </v-simple-checkbox>
</template>

<script>

export default {
  name: "CheckBox",
  components: {
  },
  props: {
    item: Object,
  },
  data: function () {
    return {
      response: null,
    };
  },
  watch: {},
  computed: {},
  created() {},
  methods: {
    changed() {
      this.$emit('click');
    },
    clicked(event) {
      event.stopPropagation();
    }
  },
};
</script>
<style lang="scss" scoped>
/*
.checkbox-selector {  
  align-content: center;
    height: 30px;
    width: 30px;
    padding-top: 6px;
    margin-top: -6px;
    padding-left: 6px;
    margin-left: -6px;
    display: inline;
    border: solid 1px lightgray;
}
.checkbox-selector-right {  
    float: right;
    padding-right: 6px;
    padding-left: 0;
    padding-top: 6px;
    margin-top: -6px;
    margin-left: 10px;
}
.checkbox-selector:hover {  
    background-color: #e4e1e1;
    border-radius: 50%;
    transition: inherit;
} */
.rm-cb i {
  font-size: 20px;
}
</style>